import * as React from 'react';
import { Box, EmptyState } from '@wix/design-system';
import SomethingWentWrong from '../../../assets/images/something-went-wrong.svg';
import { WithTranslation, withTranslation } from 'react-i18next';

export interface CashierEmptyStateProps extends WithTranslation {}

const CashierEmptyStateComp = (props: CashierEmptyStateProps) => {
  const { t } = props;

  return (
    <Box width="100%" align="center" verticalAlign="middle" height="350px">
      <EmptyState
        theme="page"
        image={<SomethingWentWrong />}
        title={t('quoteview.error.title')}
        subtitle={t('quoteview.error.message')}
      />
    </Box>
  );
};

export const CashierEmptyState = withTranslation()(CashierEmptyStateComp);
